import { AffCode } from '../../../affcode/shared/affcode.model';
import { AffCodeSelectorComponent } from '../../../affcode/affcode-selector/affcode-selector.component';
import { ProfileService } from '../../shared/profile.service';
import { AffCodeService } from '../../../affcode/shared/affcode.service';
import { Component, OnChanges, Input, ViewChild, OnInit } from '@angular/core';
import { AffProsAndAffCodeType } from '../../shared/model/aff-pros-and-aff-code-type.model';
import { EntityDomainDto } from 'src/app/affcode/shared/dto/entity-domain.dto';
import { Entity } from 'src/app/entity/shared/entity.model';
import { EntityService } from 'src/app/entity/shared/entity.service';
import { EntityDomainService } from 'src/app/admin/entity-domains/shared/entity-domain.service';
import { ConfigSettingService } from 'src/app/config/shared/config-setting/config-setting.service';
import { MemberActivityTypeModel } from 'src/app/member/shared/member-activity-type.model';
import { ProfileEditDropActivityDialogComponent } from './profile-edit-drop-activity-dialog/profile-edit-drop-activity-dialog.component';
@Component({
  selector: 'wl-profile-edit-affiliations',
  templateUrl: './profile-edit-affiliations.component.html',
  styleUrls: ['./profile-edit-affiliations.component.css'],
    standalone: false
})
export class ProfileEditAffiliationsComponent implements OnInit, OnChanges {
  @Input() profileId: number;
  @Input() isMember: number;

  @ViewChild(AffCodeSelectorComponent) _affCodeSelectorComponent: AffCodeSelectorComponent;
  @ViewChild(ProfileEditDropActivityDialogComponent) private _dropActivityDialog: ProfileEditDropActivityDialogComponent;

  public affiliations: Array<AffProsAndAffCodeType>;
  private _pristineAffCodes: string;
  private _removedEntityAffcodes: Array<AffCode> = [];
  private _entities: Array<Entity> = [];
  private _entityDomains: Array<EntityDomainDto> = [];
  displayDropActivityDialog: boolean = false;
  dropMemberActvities: Array<MemberActivityTypeModel> = [];

  constructor(
    private _affCodeService: AffCodeService,
    private _profileService: ProfileService,
    private _entityService: EntityService,
    private _entityDomainService: EntityDomainService,
    private _configSettingService: ConfigSettingService
  ) {}

  ngOnInit(): void {
    this._entityService.getEntities().then((result) => {
      this._entities = result;
    });

    this._entityDomainService.getAllEntityDomains().then((result) => {
      this._entityDomains = result;
    });
  }

  ngOnChanges() {
    if (this.profileId) {
      this._profileService.getProfileAffCodesByAffCodeType(this.profileId, true).then((data: Array<AffProsAndAffCodeType>) => {
        this.affiliations = data;
        const selectedAffs: Array<AffCode> = [];
        this.affiliations.forEach((item) => {
          item.AffPros.forEach((affPro) => {
            selectedAffs.push({
              AffCodeType: item.AffCodeType,
              AffCode: affPro,
              Selected: false,
            } as AffCode);
          });
        });
        this._affCodeSelectorComponent.selectedAffCodes = selectedAffs;
        this._affCodeSelectorComponent.updateValueFromSelectedAffCodes();
        this.setPristine();
      });
    }
  }

  async save() {
    let entities = await this._profileService.getProfileEntities(this.profileId);
    const selectedAffCodes = this._affCodeSelectorComponent.selectedAffCodes.map((x) => x.AffCode);
    if (!this._pristineAffCodes) {
      this._pristineAffCodes = '[]';
    }
    const originalAffCodes: Array<string> = JSON.parse(this._pristineAffCodes);
    const removedAffCodes = originalAffCodes.filter((x) => !selectedAffCodes.some((y) => x === y));
    const addedAffCodes = selectedAffCodes.filter((x) => !originalAffCodes.some((y) => x === y));
    let promise = Promise.resolve();
    this._removedEntityAffcodes = [];
    if (addedAffCodes.length > 0) {
      promise = this._affCodeService.addAffCodesToProfile(this.profileId, addedAffCodes);
    }
    if (removedAffCodes.length > 0) {
      // Flatten AffCodeTypes and then filter for AffCodes that are being removed and are entities
      this._removedEntityAffcodes = this._affCodeSelectorComponent.affCodeTypes
        .reduce((a, b) => [...a, ...b.AffCodes], [])
        .filter((affCode) => removedAffCodes.includes(affCode.AffCode) && affCode.IsEntity === true);

      promise = this._affCodeService.removeAffCodesForProfile(this.profileId, removedAffCodes);
    }
    return promise
      .then(() => this.setPristine())
      .then(async () => {
        if (this._removedEntityAffcodes.length > 0) {
          let settingBatch = this.getEntitySettingBatch(this._removedEntityAffcodes[0].AffCode);
          let configSettings = await this._configSettingService.getDropMembershipActionSettingsByBatch(settingBatch ?? 'default');
          if (configSettings.UncheckMemberIfNotInOtherEntity && entities.length == 1 && this.isMember) {
            this._dropActivityDialog.openDialog(this.profileId, this._entities[0].EntityID);
            await this._dropActivityDialog.onClosed();
          }
          if (settingBatch) {
            this._affCodeService.removeProfileFromEntity(this.profileId, settingBatch);
          } else {
            this._affCodeService.removeProfileFromEntity(this.profileId);
          }
        }
      });
  }
  private setPristine() {
    this._pristineAffCodes = JSON.stringify(this._affCodeSelectorComponent.selectedAffCodes.map((x) => x.AffCode));
  }

  private getEntitySettingBatch(affCode: string) {
    let entity = this._entities.find((x) => x.AffCode == affCode);
    if (entity != undefined) {
      let entityDomain = this._entityDomains.find((x) => (x.EntityID = entity.EntityID));
      return entityDomain != undefined ? entityDomain.SettingBatch : null;
    }
  }
}
